import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box,  Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel, Checkbox,
    Stack, HStack, Image, Wrap, WrapItem, Center, VStack, Badge, Link, useToast
} from '@chakra-ui/react';
import { orderBy, sortBy } from 'lodash';
import { withNamespaces } from 'react-i18next';

import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab, getDoctorList } from '../../redux/selectors';
import { ACTIVE_DOCTOR_TAB } from '../../redux/constants';
import { apiLoadListDoctor } from '../../redux/apis/DoctorApis';

import { MAIN_COLOR, PATIENT_INFORMATION_MAX_AGE } from '../../constants'
import { displayConfirmAlert } from "../utils"

import Header from '../Home/Header';
import Navbar from '../Home/Navbar';
import NoDataPage from '../../components/NoData';
import NoEventPage from '../../components/NoEvent';

const DOCTOR_INFO_POPUP_WIDTH = 200;
const SELECTED_BUTTON_COLOR = "blue.500";
const WORK_DAILY_NUMBERS = {
    0: "Chủ nhật",
    1: "Thứ 2",
    2: "Thứ 3",
    3: "Thứ 4",
    4: "Thứ 5",
    5: "Thứ 6",
    6: "Thứ 7"
}

function Doctor(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "makeDoctorAppointmentDatas", "loginCookie"]);

    const [ isEnableShowDoctorInfo, setIsEnableShowDoctorInfo ] = useState(false);
    const [ isShowDoctorInfo, setIsShowDoctorInfo ] = useState(false);
    const [ doctorList, setDoctorList ] = useState([]);
    const [ doctorInfo, setDoctorInfo ] = useState(null);
    const [ doctorInfoPopupLeft, setDoctorInfoPopupLeft ] = useState(0);
    const [ doctorInfoPopupTop, setDoctorInfoPopupTop ] = useState(0);
    const [ isShowCircularProgress, setIsShowCircularProgress ] = useState(false);
    const [ selectedSortType, setSelectedSortType ] = useState("ALL");

    const navigate = useNavigate();
    const mounted = useRef();
    const doctorInfoPopupRef = useRef();
    const toast = useToast();
    const toastId = "doctor-toast";
    const val = useRef();
    const t = props.t;

    useEffect(() => {
        if(!mounted.current) {
            if(!cookies.selectedClinic?.data?.id) {
                displayConfirmAlert("Bạn vui lòng chọn phòng khám trước khi tiếp tục!", () => {
                    navigate("/");
                });
            } else {
                props.apiLoadListDoctor({ 
                    company_id: cookies.selectedClinic?.data?.id,
                    order_by: "name",
                    order_dir: "ASC" 
                });
                props.setNavTab(ACTIVE_DOCTOR_TAB);
            }

            if(
                cookies.makeDoctorAppointmentDatas?.data?.patientDetail && cookies.makeDoctorAppointmentDatas?.data?.departmentDetail
             && !cookies.makeDoctorAppointmentDatas?.data?.doctorDetail
            ) {
                if(!toast.isActive(toastId)) {
                    toast({
                        id: toastId,
                        title: "Bước tiếp theo",
                        description: "Chọn bác sỹ khám",
                        status: "warning",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom-right"
                    })
                }
            }
            mounted.current = true;
        }

        val.current = props
    }, [props]);

    useEffect(() => {
        return () => {
            if(props.currentNavTab !== val.current.currentNavTab) {
                toast.closeAll()
            }
        }
    }, []);

    useEffect(() => {
        setDoctorList(props.doctorList);
    }, [props.doctorList]);

    const handleMouseOverDoctor = (boundingRect, data) => {
        const { x, y, width, top } = boundingRect;

        if((window.document.body.clientWidth - x) <= 500) {
            setDoctorInfoPopupLeft(x - DOCTOR_INFO_POPUP_WIDTH - 10);
        } else {
            setDoctorInfoPopupLeft(x + width + 10);
        }
        setDoctorInfoPopupTop(top);
        setDoctorInfo(data);
        setIsShowDoctorInfo(isEnableShowDoctorInfo);
    }

    const handleMouseOutDoctor = () => {
        if(isShowDoctorInfo) {
            setIsShowDoctorInfo(false);
        }
    }

    const handleConfirm = (data) => {
        if(!cookies.makeDoctorAppointmentDatas?.data?.patientDetail) {
            displayConfirmAlert("Bạn chưa điền thông tin đăng ký khám!", () => navigate("/"));
        } else if(!cookies.makeDoctorAppointmentDatas?.data?.departmentDetail) {
            displayConfirmAlert("Bạn chưa chọn phòng khám!", () => navigate("/department"));
        } else {
            setCookie("makeDoctorAppointmentDatas", 
                { 
                    data: {
                        ...cookies.makeDoctorAppointmentDatas?.data,
                        doctorDetail: data,
                    } 
                }, 
                { 
                    path: '/', maxAge: PATIENT_INFORMATION_MAX_AGE
                }
            );

            navigate('/service_prices');
        }
    }

    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <Flex flexDirection="column">
                <Header />
                <Navbar />
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </Flex>
        )
    }

    return (
        <React.Fragment>
            <Flex flexDirection="column">
                <Header />
                <Navbar />

                <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} width="100vw" py={8}>
                    <VStack spacing={4}>
                        <VStack marginBottom={{ base: "5px", md: "5px", lg: "20px" }}>
                            <Text fontSize="20px" fontWeight="700" color="#007F4E">{t("Total_Doctor")}</Text>
                            <HStack>
                                <Image alt="component" src="/images/clinics/icons/hair_listen_doctor.png" />
                                <Text fontSize="32px" fontWeight="800" color="#007F4E">{doctorList && doctorList.length}</Text>
                            </HStack>
                        </VStack>
                        
                        <Button bg={selectedSortType === "ALL" ? SELECTED_BUTTON_COLOR : MAIN_COLOR} color="#FFFFFF" 
                            _hover={{ color: "#FE8B39" }} width={{ base: "80%", md: "80%", lg: "100%" }} 
                            borderTopRightRadius="8vw" borderBottomRightRadius="8vw" justifyContent="flex-start"
                            onClick={() => {
                                setDoctorList(props.doctorList);
                                setSelectedSortType("ALL");
                            }}
                        >
                            <Text fontSize="16px" fontWeight="700">{t("All")}</Text>
                        </Button>

                        <Button bg={selectedSortType === "TODAY" ? SELECTED_BUTTON_COLOR : MAIN_COLOR} color="#FFFFFF" 
                            _hover={{ color: "#FE8B39" }} width={{ base: "80%", md: "80%", lg: "100%" }} 
                            borderTopRightRadius="8vw" borderBottomRightRadius="8vw" justifyContent="flex-start"
                            onClick={() => {
                                const nowDay = new Date().getDay();
                                const newDoctorList = doctorList.filter(doctor => doctor.work_daily && doctor.work_daily.filter(item => item.label.indexOf(WORK_DAILY_NUMBERS[nowDay]) !== -1).length > 0);
                                setDoctorList(newDoctorList);
                                setSelectedSortType("TODAY");
                            }}
                        >
                            <Text fontSize="16px" fontWeight="700">{t("Today_Doctor")}</Text>
                        </Button>

                        <Button bg={selectedSortType === "SORT_BY_SPECIIALIST" ? SELECTED_BUTTON_COLOR : MAIN_COLOR} color="#FFFFFF" 
                            _hover={{ color: "#FE8B39" }} width={{ base: "80%", md: "80%", lg: "100%" }}  
                            borderTopRightRadius="8vw" borderBottomRightRadius="8vw" justifyContent="flex-start"
                            onClick={() => {
                                const newDoctorList = orderBy(doctorList, ['specialist']);
                                setDoctorList(newDoctorList);
                                setSelectedSortType("SORT_BY_SPECIIALIST");
                            }}
                        >
                            <Text fontSize="16px" fontWeight="700">{t("Sort_By_Specialist")}</Text>
                        </Button>

                        <Button bg={selectedSortType === "SORT_BY_TIME" ? SELECTED_BUTTON_COLOR : MAIN_COLOR} color="#FFFFFF" 
                            _hover={{ color: "#FE8B39" }} width={{ base: "80%", md: "80%", lg: "100%" }}  
                            borderTopRightRadius="8vw" borderBottomRightRadius="8vw" justifyContent="flex-start"
                            onClick={() => {
                                const newDoctorList = orderBy(doctorList, ['from_time']);
                                setDoctorList(newDoctorList);
                                setSelectedSortType("SORT_BY_TIME");
                            }}
                        >
                            <Text fontSize="16px" fontWeight="700">{t("Sort_By_Time")}</Text>
                        </Button>

                        <Checkbox colorScheme='orange' minW="100px" isChecked={isEnableShowDoctorInfo}
                            onChange={(evt) => setIsEnableShowDoctorInfo(evt.currentTarget.checked)}
                        >
                            <Text fontWeight="600" color="blue.700">{t("More_Doctor_Information")}</Text>
                        </Checkbox>
                    </VStack>

                    {
                        (doctorList?.length > 0) &&
                            <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} flexWrap="wrap" align="flex-start"
                                mx={8} gap={0}
                            >
                                {
                                    doctorList.map((item, idx) => {
                                        let workDailyText = "";

                                        if(item.work_daily) {
                                            const work_daily_sortBy = sortBy(item.work_daily, ["label"]);
                                            work_daily_sortBy.map(doc => {
                                                workDailyText += workDailyText.length === 0 ? doc.label : ", " + doc.label;
                                            })
                                        }
                                        
                                        return (
                                            <VStack key={item.id} m={2} p={2} borderRadius={8} borderWidth="2px" 
                                                borderColor={ cookies.makeDoctorAppointmentDatas?.data?.doctorDetail?.id === item.id ? "green.500" : "black.700" } 
                                                w={{ base: "100%", md: "400px", lg: "400px" }} boxShadow="lg"
                                                _hover={{ bg: "#cfd8dc", cursor: 'pointer' }} alignItems="center" align="flex-start" 
                                                onClick={() => handleConfirm(item)}
                                                onMouseOver={(evt) => {
                                                        handleMouseOverDoctor(evt.currentTarget.getBoundingClientRect(), item);
                                                    }
                                                }
                                                onMouseOut={(evt) => {
                                                    handleMouseOutDoctor();
                                                }}
                                            >
                                                <HStack width="100%" p={2}>
                                                    {
                                                        item.portrait_url &&
                                                        <Image alt="doctor_portrait" width="115px" height="94px" 
                                                            src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/doctors/${item.portrait_url}`} 
                                                        />
                                                    }
                                                    {
                                                        !item.portrait_url && 
                                                        <Image alt="no_doctor_portrait" width="115px" height="94px" 
                                                            src={`/images/doctor_80x80.png`} 
                                                        />
                                                    }
                                                    <VStack spacing={0} justifyContent="flex-start" alignItems="flex-start" mx={2}>
                                                        <Text color="#007F4E" fontSize="16px" fontWeight="700">
                                                            {item.name}
                                                        </Text>
                                                        <Badge colorScheme='blue'>{item.specialist}</Badge>
                                                        <Text color="#01579b" fontSize="14px">{workDailyText}</Text>
                                                        <Text color="#b71c1c">{`${item.from_time} - ${item.to_time}`}</Text>
                                                    </VStack>
                                                </HStack>
                                            </VStack>
                                        )
                                })
                            }
                        </Flex>
                    }

                    {
                        (doctorList?.length === 0) &&
                        <VStack width="100%" justify="flex-start" align="center" mt={20} px={4} spacing={2}>
                            <NoDataPage text="Hiện tại chưa có dữ liệu về Bác sỹ khám."/>
                            {
                                (cookies?.loginCookie && cookies?.loginCookie?.data?.company_id === cookies?.selectedClinic?.data?.id) &&
                                <Text fontSize={{ base: "16px", md: "18px", lg: "18px" }} fontWeight="700">
                                    Bạn có thể tạo dữ liệu Bác sỹ khám từ
                                    <Link color="teal.500" href='/settings' fontWeight="700" target="_blank" ml={1}>Danh mục bác sỹ</Link>
                                </Text> 
                            }
                        </VStack>
                    }
                </Flex>
            </Flex>

            {
                isShowDoctorInfo &&
                <Box ref={doctorInfoPopupRef} bg="blue.100" position="fixed" left={doctorInfoPopupLeft} top={doctorInfoPopupTop}
                    borderRadius={10} p={2} fontSize="14px" w={`${DOCTOR_INFO_POPUP_WIDTH}px`}
                >
                    <Text marginTop="5px" color="#007F4E" fontSize="18px" fontWeight="700">{doctorInfo?.name}</Text>
                    <VStack mt={4} justify="flex-start" align="flex-start" spacing={0}>
                        <Text>{t("Phone")}</Text>
                        <Text fontWeight="700">{doctorInfo?.phone}</Text>
                    </VStack>
                    <VStack justify="flex-start" align="flex-start" spacing={0}>
                        <Text>{t("Address")}</Text>
                        <Text fontWeight="700">{doctorInfo?.address}</Text>
                    </VStack>
                    <VStack justify="flex-start" align="flex-start" spacing={0}>
                        <Text>{t("Education")}</Text>
                        <Text fontWeight="700">{doctorInfo?.education}</Text>
                    </VStack>
                    <VStack justify="flex-start" align="flex-start" spacing={0}>
                        <Text>{t("Experience")}</Text>
                        <Text fontWeight="700">{doctorInfo?.experience}</Text>
                    </VStack>
                    <VStack justify="flex-start" align="flex-start" spacing={0}>
                        <Text>{t("Description")}</Text>
                        <Text fontWeight="700">{doctorInfo?.description}</Text>
                    </VStack>
                </Box>
            }

            {
                isShowCircularProgress &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">{t("Loading")}</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const currentNavTab =           getCurrentNavTab(state);
    const doctorList =              getDoctorList(state);

    return { currentNavTab, doctorList };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListDoctor:          payload => dispatch(apiLoadListDoctor(payload)),

    setNavTab:                  payload => dispatch(setNavTab(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Doctor));